/**
 * Notes Component.
 * Its returns `div` element with Kepler `FormField` Component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import FormField from 'kepler/lib/components/FormField';
import _unescape from 'lodash/unescape';

const createMarkup = encodedHtml => ({
  __html: _unescape(encodedHtml),
});

/* eslint-disable react/no-danger */
const Notes = ({ label }) => (
  <FormField>
    <div dangerouslySetInnerHTML={createMarkup(label)} />
  </FormField>
);

// Notes Props Types.
Notes.propTypes = {
  label: PropTypes.string,
};

// Notes Props default values.
Notes.defaultProps = {
  label: '',
};

export default Notes;
